import {
	IconBookOpen4Outline18 as BookIcon,
	IconStackPerspectiveOutline18 as ChangelogIcon,
} from "nucleo-ui-outline-18"

import { usePortalContentCounts } from "@/screens/settings/portal-content-counts"
import {
	settingsNavGroupClass,
	SettingsNavRow,
} from "@/screens/settings/settings-pages/settings-nav-row"
import { SettingsSection } from "@/screens/settings/settings-switches/settings-section"

/** What a portal serves today, so the page is not settings alone. `null` is main. */
export function PortalContentCard({
	portalInstanceId,
}: {
	portalInstanceId: string | null
}) {
	const counts = usePortalContentCounts()(portalInstanceId)

	return (
		<>
			<SettingsSection
				title="Content"
				description="Assign an article or a changelog to this portal from its own editor."
				className="mb-3"
			/>
			<div className={settingsNavGroupClass}>
				<SettingsNavRow
					icon={BookIcon}
					title="Docs"
					description={`${counts.articles} ${counts.articles === 1 ? "article" : "articles"} in ${counts.groups} ${counts.groups === 1 ? "group" : "groups"}, ${counts.publishedArticles} published`}
					link="/edit-docs"
				/>
				<SettingsNavRow
					icon={ChangelogIcon}
					title="Changelog"
					description={`${counts.changelogs} ${counts.changelogs === 1 ? "changelog" : "changelogs"}, ${counts.publishedChangelogs} published`}
					link="/edit-changelog"
				/>
			</div>
		</>
	)
}
